import { Reducer } from 'redux';
import { AgendamentosState, AgendamentosTypes } from './types';

const INITIAL_STATE: AgendamentosState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  sorter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
  total: {
    total: 0,
    qtdPlat: 0,
    totalAge: 0,
    totalExp: 0,
  },
};

const reducer: Reducer<AgendamentosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AgendamentosTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AgendamentosTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        total: action.payload.total,

        pagination: action.payload.pagination,
      };
    case AgendamentosTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case AgendamentosTypes.FILTER_AGEMDAMEMTOS:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case AgendamentosTypes.SORTER_AGEMDAMEMTOS:
      return {
        ...state,
        sorter: action.payload.sorter,
      };
    case AgendamentosTypes.CLEAN_AGENDAMENTOS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
